import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {SheetTabNameValidator} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SpreadsheetTabNameValidator';
import {Workbook} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/Workbook';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {action, computed, observable} from 'mobx';
import {AnySheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {SpreadsheetTabsView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/SpreadsheetTabsView';
import {ISpreadsheetTabsDesignUIState} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignUIState';

export type ScrollBarShadows =
    {
        left:boolean,
        right:boolean
    };

export type PanelOffset =
    {
        top:number,
        left:number,
        width:number
    };

export type SheetTabOffset =
    {
        left:number,
        width:number
    };

export class SpreadsheetTabsState implements ISpreadsheetTabsDesignUIState
{
    @observable public activeSheetId:SheetId = null;
    @observable public panelOffset:PanelOffset = null;
    @observable public isScrollableTabs:boolean = false;
    @observable public isInProcess:boolean = false;
    @observable public scrollBarShadows:ScrollBarShadows = {left: false, right: false};
    @observable public dndSourceSheetIndex:number = null;
    @observable public dndSourceSheetTabOffset:SheetTabOffset = null;
    @observable public dndTargetSheetIndex:number = null;

    @observable public editorSheetName:string = null;
    @observable public editorSheetNameId:string = null;
    @observable public editorErrorsAllowed:boolean = false;

    public tabsViewInstance:SpreadsheetTabsView | null = null;

    @computed
    public get activeSheet():AnySheet
    {
        let sheet:AnySheet = commonControllers.spreadsheets.main.findAnySheetById(this.activeSheetId);

        if( !sheet )
        {
            const workbook:Workbook = commonControllers.spreadsheets.main.getRootWorkbook();

            sheet = commonControllers.spreadsheets.workbook.findSheetByIndex(workbook.id, 0);
        }

        return sheet;
    };

    @computed
    public get isEditorSheetNameInvalid():boolean
    {
        if( !this.editorSheetName )
        {
            return true;
        }
        return SheetTabNameValidator.isInvalidSheetName(this.editorSheetName);
    }

    @computed
    public get isEditorSheetNameDuplicate():boolean
    {
        if( !this.editorSheetName )
        {
            return false;
        }
        const workbook:Workbook = commonControllers.spreadsheets.main.getRootWorkbook();
        return this.editorSheetNameId !== null ? SheetTabNameValidator.sheetWithNameExists(workbook.id, this.editorSheetNameId, this.editorSheetName) : false;
    }

    @computed
    public get isEditorSheetNameValid():boolean
    {
        return !this.isEditorSheetNameInvalid && !this.isEditorSheetNameDuplicate;
    }

    public toDesignUIState():ISpreadsheetTabsDesignUIState
    {
        return {
            activeSheetId: this.activeSheetId
        }
    }

    @action
    public fromDesignUIState(state:ISpreadsheetTabsDesignUIState)
    {
        if( state.activeSheetId )
            this.activeSheetId = state.activeSheetId;
    }
}
